export var unusualSaleStatusMap = {
  1: {
    class: 'i-tips-cancel',
    label: '演出取消'
  },
  2: {
    class: 'i-tips-delay',
    label: '演出延期'
  },
  3: {
    class: 'i-tips-partial-delay',
    label: '部分延期'
  },
  4: {
    class: 'i-tips-partial-cancel',
    label: '部分取消'
  },
  5: {
    class: 'i-tips-delay-cancel',
    label: '部分取消/延期'
  },
  6: {
    class: 'i-tips-delay-cancel',
    label: '部分取消/延期'
  }
};
export var saleLabelMap = {
  1: {
    class: 'i-tips-pre',
    label: '即将开售'
  },
  // 2: { // 去掉
  //   class: 'i-tips-yu',
  //   label: '预订',
  // },
  // 3: { // 去掉
  //   class: 'i-tips-ticketing',
  //   label: '',
  // },
  4: {
    class: 'i-tips-soldout',
    label: '已无票'
  },
  5: {
    class: 'i-tips-finish',
    label: '已结束'
  },
  11: {
    class: 'i-tips-pre-will',
    label: '即将开抢'
  }
};